import { INSTRUMENT_CODES } from 'const'
import StringInstrument from 'components/Tools/Sections/StringInstrument'
import ToolLayout from 'layouts/ToolLayout'
import UkuleleJSON from 'assets/chords/ukulele.json'

const ToolPageUkuleleBaritone = () => {
  return (
    <ToolLayout>
      <StringInstrument
        tuning="baritone"
        instrumentCode={INSTRUMENT_CODES.ukulele}
        stringChordLibraryJSON={UkuleleJSON}
      />
    </ToolLayout>
  )
}

export default ToolPageUkuleleBaritone
